export const defaultState = () => {
  return {
    sectionsOrders: {
      left: [],
      right: [],
    },
    recentPages: [],
    newTemplates: [],
    topIntegrations: [],
    banner: [],
    blog: [],
    faqs: [],
    changelog: [],
    openCustom: false,
    loading: false,
    firstCallGetApi: false,
    isYearly: false,
    dynamicContentPricing: {},
    dynamicTriggerPricing: {},
    paymentInfo: {},
    pricingPageLoading: false,
    bfcmBannerClosed: true
  };
};

const state = defaultState();

export default state;
